import React, {useState} from "react";
import {useQuery, useQueryClient} from "react-query";
import {useSelector} from "react-redux";
import {useSnackbar} from "notistack";
import moment from "moment";

import { get, getErrorMessage, post, put } from "../../service/Client";
import {Column, Row} from "../../components/Layout";
import HereMap from "../../components/Map/HereMap";
import NTMTable from "../../components/Table/NTMTable";
import NTMButton from "components/Buttons/NTMButton";
import AssignDevicePanel from "../Dashboard/AssignDevicePanel";
import Image from "../../components/Image";
import EditLabelModal from "../../components/Modal/EditLabelModal";

import { DEVICES, PROJECTS, SWITCH} from "../../service/Client";
import Roles from "constants/Roles"
import { alertIcon, editIcon, editIcon_over, saveIcon_over, pinIcons } from "img/icons";
import style from "../Dashboard/style.module.scss";


export default function SwitchDashboard() {
	const user = useSelector(store => store.users.data)
	const project = useSelector(store => store.session.project)
	const [center, setCenter] = useState()
	const [isModalOpen, setIsModalOpen] = useState()

	const queryClient = useQueryClient();
	const {enqueueSnackbar} = useSnackbar();
	const { data } = useQuery(["switch", { project: project.id }], () =>
		get(`${SWITCH}/project/${project.id}`), {
		initialData: [],
		refetchInterval: 5000,
	})

	const zoom = 7

	function showError(e) {
		enqueueSnackbar(getErrorMessage(e), {variant: "error"});
	}
	function devicePopUp(name, ts) {
		return `<div class="bubble">
									<div class="name">id</div><div>${name}</div>
									<div class="name">ultimo contatto</div><div>${moment(ts).format("DD-MM-YYYY HH:mm")}</div>
								</div>`
	}

	function changeLabel(label) {
		post(`${DEVICES}/${isModalOpen}/label`, {body: label, headers: {"Content-Type": "text/plain"}})
			.then(() => queryClient.invalidateQueries('switch'))
			.catch(showError);
		setIsModalOpen(null);
	}

	function disassociate(device) {
		put(`${PROJECTS}/${project.id}/devices`, {body: data.filter(d => d.device !== device.device).map(d => d.device)})
			.then(() => queryClient.invalidateQueries('switch'))
			.catch(showError);
	}

	let markers = [];
	if(markers) {
		data.forEach(d => d.lat && markers.push({
				lat: d.lat,
				lng: d.lng,
				data: devicePopUp(d.label||d.device, d.updated_at),
				icon: d.status ? pinIcons.red : pinIcons.green
			}))
	}

	let body = data.map(d => {
		return {
			...d,
			updated_at:new Date(d.updated_at).toLocaleString('it-IT')
		}
	});

	if (!center && markers && markers.length > 0) {
		setCenter({ lat: markers[0].lat, lng: markers[0].lng })
	}

		return (
			<div className={"animated fadeIn container"}>
				<Row className={style.box}>
					<HereMap
						center={center || { lat: 40.967320, lng: 17.115670 }}
						zoom={zoom}
						theme={"normal.day"}
						markers={markers}
						className={style.map}
					/>
				</Row>
				<Row className={style.box}>
					<NTMTable
						header={[
							{
								Header: "ID",
								accessor: 'device',
								Cell: props =>
									<Row style={{ justifyContent: "space-around", alignItems: "baseline" }}>
										<span style={{paddingRight: "0.5rem"}}>{props.original.device}</span>
										{Roles.isSuperUser(user) && <NTMButton primary onClick={() => disassociate(props.original)}>Rimuovi</NTMButton>}
									</Row>
							},
							{
								Header: "Label",
								accessor: 'label',
								Cell: props => <Row style={{ justifyContent: "space-around" }}>
									<span
										style={{ paddingRight: "0.5rem" }}>{props.original.label || props.original.device}</span>
									{Roles.isAdmin(user) && <Image
										src={editIcon}
										hover={editIcon_over}
										onClick={() => setIsModalOpen(props.original.device)}
									/>}
								</Row>
							},
							{
								Header: "ULTIMO CONTATTO",
								accessor: 'updated_at'
							},
							{
								Header: "STATO",
								accessor: 'status',
								Cell: props =>
									<div>
										{
											props.original.status ?
												<Row style={{align: "center"}}>
													<Column>
														<Image src={alertIcon} />
														<strong> Aperta</strong>
													</Column>
												</Row>
												:
												<Row style={{alignItems: "center"}}>
													<Column>
														<Image src={saveIcon_over} />
														<span> Chiusa</span>
													</Column>
												</Row>
										}
									</div>
							},
							{
								Header: "BATTERIA",
								accessor: 'battery',
								Cell: props =>
									<div>
										{
											props.original.battery ?
												<Row style={{alignItems: "center"}}>
													<Column className={`progress ${style.battery}`}>
														<div
															className="progress-bar"
															role="progressbar"
															aria-valuenow={props.original.battery}
															aria-valuemin="0"
															aria-valuemax="100"
															style={{width: props.original.battery * 100 + "%"}}
														/>
													</Column>
													<Column>
														{(props.original.battery * 100).toFixed()}%
													</Column>
												</Row>
												:
												"-"
										}
									</div>
							}
						]}
						body={body || []}
					/>
				</Row>
				{Roles.isSuperUser(user) &&
					<AssignDevicePanel devices={data.map(d => d.device)} />
				}

				<EditLabelModal isOpen={!!isModalOpen}
					onClose={() => setIsModalOpen(!isModalOpen)}
					onSubmit={changeLabel}
				/>
			</div>
		);
}
